import { TableViewStore, BaseListViewStore } from "core/stores";
import { TrackingCaseDocumentFieldValueService, TrackingCaseDocumentService } from "application/tracking-case/services";
import { action, observable } from "mobx";
import { toDate } from 'core/utils';
import { ModalParams } from 'core/models';

class TrackingCaseDocumentFieldValueListViewStore extends BaseListViewStore {
    @observable accessor trackingCaseDocumentName = null;
    @observable.ref accessor trackingCaseId = null;

    constructor(rootStore) {
        const trackingCaseDocumentId = rootStore.routerStore.routerState.params.id;

        const service = new TrackingCaseDocumentFieldValueService(rootStore.application.baasic.apiClient);

        super(rootStore, {
            autoInit: true,
            routes: {
            },
            actions: () => {
                return {
                    find: async params => {
                        const response = await service.find({...params, trackingCaseDocumentId: trackingCaseDocumentId, embed: 'documentFormField,documentFormField.documentFormFieldType'});
                        response.data.item.forEach(item => {
                            if(!item.documentFormField){
                                item.documentFormField = {};
                            }

                            if(item.documentFormField.documentFormFieldType){
                                switch(item.documentFormField.documentFormFieldType.abrv){
                                    case "date": item.value = toDate(item.value); item.originalValue = toDate(item.originalValue); break;
                                }
                            }
                        });

                        return response.data;
                    },
                    populate: async trackingCaseDocumentId => {
                        const response = await this.trackingCaseDocumentService.populate({id: trackingCaseDocumentId});
                        return response.data;
                    }
                };
            }
        });

        this.setTableStore(
            new TableViewStore(this.queryUtility, {
                columns: [
                    {
                        key: "documentFormField.order",
                        title: "TRACKING_CASE_DOCUMENT_FIELD_VALUE.LIST.COLUMNS.TAB_ORDER",
						sortable:true,
                    },
                    {
                        key: "documentFormField.name",
                        title: "TRACKING_CASE_DOCUMENT_FIELD_VALUE.LIST.COLUMNS.DOCUMENT_FORM_FIELD",
						sortable:false,
                        onClick: item => this.openEditPopup(item.id)
                    },
                    {
                        key: "value",
                        title: "TRACKING_CASE_DOCUMENT_FIELD_VALUE.LIST.COLUMNS.VALUE"
                    },
                    {
                        key: "originalValue",
                        title: "TRACKING_CASE_DOCUMENT_FIELD_VALUE.LIST.COLUMNS.ORIGINAL_VALUE"
                    }
                ],
                actions: {
                    onEdit: item => this.openEditPopup(item.id)
                }
            })
        );

        this.trackingCaseDocumentId = trackingCaseDocumentId;

        this.editModal = new ModalParams({});

        this.trackingCaseDocumentService = new TrackingCaseDocumentService(rootStore.application.baasic.apiClient);

        this.getTrackingCaseDocumentName();
    }
    
    @action.bound
    async getTrackingCaseDocumentName() {
        var response = await this.trackingCaseDocumentService.get(this.trackingCaseDocumentId, { embed: "documentType" });
        if(response.data) {
            this.trackingCaseId = response.data.trackingCaseId;

            var validTo = response.data.validTo ?  ` - ${toDate(response.data.validTo)}` : '';
            this.trackingCaseDocumentName = `${response.data.name} (${response.data.documentType.name}) | ${toDate(response.data.validFrom)}${validTo}`;
        }
    }

    @action.bound
    openEditPopup(id) {
        this.editModal.open({
            id: id,
            fetchTable: () => {
                this.queryUtility.fetch();
            }
        });
    }

    @action.bound
    async populate() {
        var { notificationStore } = this.rootStore;

        try{
            await this.actions.populate(this.trackingCaseDocumentId);

            notificationStore.success('TRACKING_CASE_DOCUMENT_FIELD_VALUE.MESSAGES.POPULATE_SUCCESS');
        } catch (err) {
            notificationStore.error('TRACKING_CASE_DOCUMENT_FIELD_VALUE.MESSAGES.POPULATE_ERROR', err);
        }

        this.queryUtility.fetch();
    }

    @action.bound
    async openDocumentView() {
        this.rootStore.routerStore.goTo("master.app.main.tracking-case.documents.field-values-edit", { trackingCaseDocumentId: this.trackingCaseDocumentId });
    }
    
    @action.bound
    async goBack() {
        this.rootStore.routerStore.goBack();
    }
}

export default TrackingCaseDocumentFieldValueListViewStore; 